import { useWidgetChat } from '@widgets/messenger/compositions/useWidgetChat'
import { useWidgetPopovers } from '@widgets/messenger/compositions/useWidgetPopovers'
import { isChatEndedState, isChatRatedState } from '@widgets/messenger/types/chat/chat'
import type { PopoverName } from '@widgets/messenger/types/popover'

const satisfactionSurveyCommentPopoverName: PopoverName = 'satisfactionSurveyComment'
const satisfactionSurveyRatePopoverName: PopoverName = 'satisfactionSurveyRate'
const endChatPopoverName: PopoverName = 'endChat'

export const useWidgetChatPopovers = () => {
  const { chatState, userEmail, isSatisfactionSurveyShown, endChat, sendSurveyRate, sendSurveyComment } =
    useWidgetChat()
  const { openPopover, closePopover } = useWidgetPopovers()

  const openSatisfactionSurveyCommentPopover = () => {
    if (!isSatisfactionSurveyShown.value) return
    const chatStateValue = chatState.value
    if (!isChatRatedState(chatStateValue)) return

    openPopover(satisfactionSurveyCommentPopoverName, () => {
      return {
        rate: chatStateValue.rate,
        onSendComment: async (comment: string) => {
          await sendSurveyComment(comment)
          closePopover(satisfactionSurveyCommentPopoverName)
        },
        onSkip: () => {
          closePopover(satisfactionSurveyCommentPopoverName)
        },
      }
    })
  }

  const openSatisfactionSurveyRatePopover = () => {
    if (!isSatisfactionSurveyShown.value) return
    const chatStateValue = chatState.value
    if (!isChatEndedState(chatStateValue)) return

    openPopover(satisfactionSurveyRatePopoverName, () => {
      return {
        onRate: async (rate) => {
          await sendSurveyRate(rate)
          closePopover(satisfactionSurveyRatePopoverName)
          openSatisfactionSurveyCommentPopover()
        },
        onSkip: () => {
          closePopover(satisfactionSurveyRatePopoverName)
        },
      }
    })
  }

  const openEndChatPopover = () => {
    openPopover(endChatPopoverName, () => {
      return {
        email: userEmail.value,
        onEndChat: async () => {
          await endChat()
          closePopover(endChatPopoverName)
          openSatisfactionSurveyRatePopover()
        },
        onCancel: () => {
          closePopover(endChatPopoverName)
        },
      }
    })
  }

  return {
    openEndChatPopover,
    openSatisfactionSurveyRatePopover,
    openSatisfactionSurveyCommentPopover,
    closePopover,
  }
}
